import type { ContactUsSectionModel } from '../../../api/interfaces/contactUsSectionModel';
import { useMetrics } from '../../../common/composables/useMetrics';

export function useSectionInteractions(pageName?: string) {
  const { metricHandler } = useMetrics(pageName || 'contact-us');
  // handle section click actions with proper analytics tracking
  const handleSectionClick = (section: ContactUsSectionModel, phoneNumber?: { tel: string, callPhone: (tel: string) => void }): void => {
    switch (section.section) {
      case 'Chat':
        // Dispatch a global custom event to open the new chat widget
        window.dispatchEvent(new CustomEvent('open-custom-chat'));
        if (section.adobeTag) {
          metricHandler(section.adobeTag, 'HELP');
        }
        break;
      case 'Email':
        if (section.adobeTag) {
          metricHandler(section.adobeTag, 'HELP');
        }
        if (section.redirectUrl) {
          window.location.href = section.redirectUrl;
        }
        break;
      default:
        // Handle other section types if needed
        if (section.adobeTag) {
          metricHandler(section.adobeTag, 'HELP');
        }
        if (phoneNumber) {
          // handle phone number interaction
          phoneNumber.callPhone(phoneNumber.tel);
        }
        if (section.redirectUrl && !phoneNumber) {
          window.location.href = section.redirectUrl;
        }
        break;
    }
  };

  return {
    metricHandler,
    handleSectionClick,
  };
}
